export default __webpack_public_path__ + "static/media/puffer_xeflex.3c906a8a.jpg";